import { FiChevronRight } from 'react-icons/fi';

/**
 * Reusable tap-to-navigate group tile for the mobile session home.
 * Carries a progress bar plus a count pill; both share one pillState value so
 * the bar's fill colour tracks the pill (spec §2).
 *
 * Count pill states:
 *   empty   (0/n)  — muted grey border + grey text
 *   partial (1..n-1) — warning border + warning text
 *   complete (n/n) — filled green (matches Badge variant="success")
 *
 * Props:
 *   groupCode   — primary name (e.g. "DB.1")
 *   location    — secondary muted line (e.g. "B00A / R1040"); omit if empty
 *   testedCount — number of assets tested in this group
 *   totalCount  — total assets in this group
 *   onClick     — tap handler
 *   className   — extra classes
 */
export default function SessionGroupTile({
  groupCode,
  location = '',
  testedCount = 0,
  totalCount = 0,
  onClick,
  className = '',
  ...props
}) {
  const pillState = totalCount > 0 && testedCount === totalCount
    ? 'complete'
    : testedCount > 0
      ? 'partial'
      : 'empty';

  const progressPct = totalCount > 0
    ? Math.round((testedCount / totalCount) * 100)
    : 0;

  return (
    <button
      type="button"
      className={['session-group-tile', className].filter(Boolean).join(' ')}
      onClick={onClick}
      {...props}
    >
      <span className="session-group-tile__body">
        <span className="session-group-tile__name">{groupCode}</span>
        {location ? (
          <span className="session-group-tile__location">{location}</span>
        ) : null}
        <span
          className={`session-group-tile__bar session-group-tile__bar--${pillState}`}
          aria-hidden="true"
        >
          <span
            className="session-group-tile__bar-fill"
            style={{ width: `${progressPct}%` }}
          />
        </span>
      </span>

      <span className="session-group-tile__right">
        <span className={`session-group-tile__count session-group-tile__count--${pillState}`}>
          {testedCount}/{totalCount}
        </span>
        <FiChevronRight size={18} aria-hidden className="session-group-tile__chevron" />
      </span>
    </button>
  );
}
